import Vue from 'vue';
import Cookies from 'js-cookie';

Vue.component('cookie-bar-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            cookie: null,
            showCookie: true,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.cookie = Cookies.get('cookie-complience');

        if (this.cookie) {
            this.showCookie = false;
            return;
        }

        setTimeout(() => {
            this.$el.classList.remove('cookie-bar-holder--hidden');
        }, 3000);

        // this.$el.classList.remove('cookie-bar-holder--hidden');
        this.initCookie();
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        initCookie() {
            Cookies.set('cookie-complience', true, { expires: 30 });

            this.cookie = Cookies.get('cookie-complience');
        },

        closeCookieBar() {
            this.$el.classList.add('cookie-bar-holder--hidden');

            // Animation time timeout
            setTimeout(() => {
                this.showCookie = false;
            }, 400);
        },
    },
});
